import {
  IconButton,
  IconButtonProps,
  Menu,
  MenuItemProps,
  MenuProps as MenuPropsType,
  SvgIconProps,
} from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import { CSSProperties, FC, ReactNode, useId, useState } from 'react';

export type WbMoreOptionsItem = {
  onClick: MenuItemProps['onClick'];
  icon: ReactNode;
  label: ReactNode;
  dividerBefore?: boolean;
  dividerAfter?: boolean;
  id: string;
};

export type WbMoreOptionsProps = {
  className?: string;
  style?: CSSProperties;
  open: boolean;
  onClick: IconButtonProps['onClick'];
  onClose: () => void;
  children: ReactNode;
  IconProps?: SvgIconProps;
  MenuProps?: Omit<MenuPropsType, 'open' | 'onClose'>;
};

export const WbMoreOptions: FC<WbMoreOptionsProps> = ({
  className,
  style,
  open,
  onClick,
  onClose,
  children,
  IconProps,
  MenuProps,
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const buttonId = useId();

  return (
    <>
      <IconButton
        className={className}
        style={style}
        id={buttonId}
        size="small"
        aria-haspopup="menu"
        aria-expanded={open}
        aria-label="More Options"
        ref={setAnchorEl}
        onClick={onClick}
      >
        <MoreVertIcon {...IconProps} />
      </IconButton>
      <Menu
        aria-labelledby={buttonId}
        anchorEl={anchorEl}
        anchorReference="anchorEl"
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        open={open}
        onClose={onClose}
        {...MenuProps}
      >
        {children}
      </Menu>
    </>
  );
};
